import { Component } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';

@Component({
    selector: 'button-renderer',
    template: `<button mat-icon-button (click)="btnClickedHandler($event)" matTooltip="Excluir"> 
     <mat-icon  aria-hidden="false" >close</mat-icon>
  </button>`,
    standalone: false
})

export class ButtonRendererComponent implements ICellRendererAngularComp{
  private params: any;

  agInit(params: any): void {
    this.params = params;
  }

  constructor(){}

  
  btnClickedHandler(evento) {
    this.params.clicked(this.params);
  }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }
}
